import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Loader, Money } from "@/components/common";
import { PageTitle, SearchBox, Table, Td, Stat, DriverPicker, useDebounced } from "@/pages/admin/ui";
import Modal from "@/components/Modal";
import { useNavigate } from "react-router-dom";

export default function Fees() {
  const [q, setQ] = useState("");
  const dq = useDebounced(q);
  const [data, setData] = useState(null);
  const [pick, setPick] = useState(false);
  const [sel, setSel] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/fees", { params: { q: dq } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))); }, [dq]);
  return (
    <div>
      <PageTitle title="الرسوم الإدارية والدفعات" sub="منفصلة تماماً عن فواتير نقل العملاء" icon={Wallet} color="text-orange-600">
        <button data-testid="fees-new-btn" onClick={() => { setSel([]); setPick(true); }} className="btn btn-md btn-orange">إضافة رسم لسائق</button>
      </PageTitle>
      {data && <div className="grid sm:grid-cols-3 gap-4 mb-5">
        <Stat label="إجمالي المطلوب" value={<Money fils={data.totals.total_fils} />} icon={Wallet} tone="orange" testid="fees-total" />
        <Stat label="إجمالي المدفوع" value={<Money fils={data.totals.paid_fils} />} icon={Wallet} tone="green" testid="fees-paid" />
        <Stat label="إجمالي المتبقي" value={<Money fils={data.totals.remaining_fils} />} icon={Wallet} tone="red" testid="fees-remaining" />
      </div>}
      <div className="mb-4"><SearchBox value={q} onChange={setQ} placeholder="ابحث بالاسم أو الرقم التسلسلي أو الهاتف" testid="fees-search" /></div>
      {!data ? <Loader /> : (
        <Table head={["السائق", "عدد الرسوم", "المطلوب", "المدفوع", "المتبقي", ""]} testid="fees-table">
          {data.items.map((d) => <tr key={d.id}>
            <Td><b>{d.full_name}</b> <span className="ltr text-slate-500">{d.serial}</span></Td><Td>{d.fees}</Td>
            <Td><Money fils={d.total_fils} /></Td><Td><Money fils={d.paid_fils} className="text-green-700" /></Td><Td><Money fils={d.remaining_fils} className="text-orange-600" /></Td>
            <Td><Link data-testid={`fees-statement-${d.serial}`} to={`/admin/fees/${d.id}`} className="btn btn-sm btn-ghost">كشف الحساب</Link></Td>
          </tr>)}
        </Table>
      )}
      <Modal open={pick} onClose={() => setPick(false)} title="اختر السائق" testid="fees-pick-driver">
        <DriverPicker selected={sel} onChange={setSel} testid="fees-driver-picker" />
        <button data-testid="fees-pick-continue" disabled={!sel.length} onClick={() => nav(`/admin/fees/${sel[0].id}`)} className="btn btn-lg btn-orange w-full">فتح حساب السائق</button>
      </Modal>
    </div>
  );
}
